import React, {useCallback} from 'react';
import block from 'bem-cn-lite';

import Sidebar from 'units/navigation/components/Sidebar/Sidebar';
import SidebarNavigationGroup from 'units/navigation/components/SidebarNavigationGroup/SidebarNavigationGroup';
import SimpleNavigationItem from 'units/navigation/components/SimpleNavigationItem/SimpleNavigationItem';
import ButtonWithIcon from 'components/Buttons/ButtonWithIcon/ButtonWithIcon';
import openIcon from 'icons/navigation-burger.svg';
import closeIcon from 'icons/navigation-close.svg';
import {NavigationConfigMobile} from 'units/navigation/models';
import EnterConsoleLink from 'components/EnterConsoleLink/EnterConsoleLink';

import './SidebarNavigation.scss';

const b = block('sidebar-navigation');

export interface SidebarNavigationProps {
    config: NavigationConfigMobile;
    className?: string;
    isOpened: boolean;
    handleOpenedChange: (isOpened: boolean) => void;
}

const SidebarNavigation: React.FunctionComponent<SidebarNavigationProps> = (props) => {
    const {config, className, isOpened, handleOpenedChange} = props;
    const iconProps = {icon: isOpened ? closeIcon : openIcon, iconSize: 36};
    const toggle = useCallback(
        (e) => {
            e.nativeEvent.stopImmediatePropagation();
            handleOpenedChange(!isOpened);
        },
        [handleOpenedChange, isOpened],
    );
    const close = useCallback(() => {
        handleOpenedChange(false);
    }, [handleOpenedChange]);

    return (
        <div className={b()}>
            <ButtonWithIcon
                className={b('button', className)}
                onClick={toggle}
                size="n"
                {...iconProps}
            />
            <Sidebar isOpened={isOpened} onClose={close}>
                <nav className={b('navigation')}>
                    <ul className={b('list')}>
                        {config.map((item) => (
                            <li key={item.title} className={b('section')}>
                                {'items' in item ? (
                                    <SidebarNavigationGroup group={item} />
                                ) : (
                                    <SimpleNavigationItem className={b('item')} {...item} />
                                )}
                            </li>
                        ))}
                    </ul>
                    <EnterConsoleLink className={b('console-button')} context="header" size="l" />
                </nav>
            </Sidebar>
        </div>
    );
};

export default SidebarNavigation;
